import React, {useContext, useState} from "react"
import { InsuranceHistorySection } from "./RefferalQuestions/InsuranceHistorySection"
import { IncidentsAndLossesSection } from "./RefferalQuestions/IncidentsAndLossesSection"
import { FelonyHistorySection } from "./RefferalQuestions/FelonyHistorySection"
import { Controller, useForm } from 'react-hook-form'
import { SessionContextStore } from "../../../context/SessionContext"
import { SessionService } from "../../../services/SessionService"
import { EventEmitterService, EventKey } from "../../../services/EventEmitterService"
import { UserProfileContextStore, ACTIONS } from "../../../context/UserProfileContext"
import { Action } from "../../../models/Action"
import {  RadioGroup, Radio, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, Checkbox, FormHelperText, Divider } from "@material-ui/core"
import FlexView from "react-flexview/lib"
import '../UserProfile.scss'
import { FirebaseService, FirebaseConfigKey } from "../../../services/FirebaseService"
import { isOver18 } from "../../../services/utils";
import { isMobile } from "react-device-detect"



export const ReferralQuestionsSection = () => {
    let sessionContext = useContext(SessionContextStore)
    const context = useContext(UserProfileContextStore)
    const { register, triggerValidation, setValue, control, errors, getValues, watch } = useForm(SessionService.isLoggedIn() ? 
        { defaultValues: { 
            had_incidents_or_losses: sessionContext.user.hadIncidentsOrLosses ? "yes" : "no",
            had_felony: sessionContext.user.hadFelony ? "yes" : "no",
            is_commercial: sessionContext.user.commercial ? "yes" : "no",
        }, mode: 'onChange' } 
        : { mode: 'onChange' })

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.USER_PROFILE_SAVE, async () => {
        let valid = await triggerValidation()
            if(valid) {
                let insuranceHistoryFormValues = getValues();
                if (!insuranceHistoryFormValues["is_commercial"]){
                    insuranceHistoryFormValues["is_commercial"] = sessionContext.user.commercial? "yes":"no";
                }
                context.dispatch(new Action(ACTIONS.SAVE_INSURANCE_HISTORY, insuranceHistoryFormValues));
            }
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
        }
    }, [])

    return (
        <React.Fragment>
            <Controller
                    defaultValue={{value: getValues('had_incidents_or_losses')}}
                    control={control}
                    name="had_incidents_or_losses"
                    rules={{ required: true }}
                    as={
                        <FlexView>
                            <div className="text-body margin-top-small">{FirebaseService.getValue(FirebaseConfigKey.INCIDENTS_LOSSES_QUESTION)}</div>
                            <RadioGroup >
                            <FlexView>
                                <FormControlLabel
                                    value={"no"}
                                    control={<Radio color="primary" />}
                                    label="No"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    value={"yes"}
                                    control={<Radio color="primary" />}
                                    label="Yes"
                                    labelPlacement="end"
                                />
                            </FlexView>
                        </RadioGroup>
                        </FlexView>
                    }
                    />
                    {!!errors.had_incidents_or_losses && <FormHelperText error>Required</FormHelperText>}

            
            <Controller
                    register={register}
                    name="had_felony"
                    defaultValue={{value: getValues('had_felony')}}
                    control={control}
                    rules={{ required: true }}
                    as={
                        <FlexView style={{flexDirection: 'row', alignSelf: 'stretch'}}>
                            <FlexView column style={{marginRight: '150px'}}>
                                {FirebaseService.getValue(FirebaseConfigKey.FELONY_QUESTION).split("*").map(question => <div style={{width:'500px'}} className="text-body margin-top-small">{question}</div>)}
                            </FlexView>
                            <RadioGroup>
                            <FlexView>
                                <FormControlLabel
                                    value={"no"}
                                    control={<Radio color="primary" />}
                                    label="No"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    value={"yes"}
                                    control={<Radio color="primary" />}
                                    label="Yes"
                                    labelPlacement="end"
                                />
                            </FlexView>
                            </RadioGroup>
                        </FlexView>
                    }
                    />
                    {!!errors.had_felony && <FormHelperText error>Required</FormHelperText>}
        </React.Fragment>
    )
}